import { render, staticRenderFns } from "./SearchPageWrapper.vue?vue&type=template&id=6c1aa8b7&lang=html"
import script from "./SearchPageWrapper.vue?vue&type=script&lang=js"
export * from "./SearchPageWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../modules/tukes/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports